import { ID } from "src/libs/interfaces/layouts";
import { __ } from "src/libs/utilities";
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, ILandingSectionDescription, ILandingSectionTitle, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";
import updateSection from "./updateSection";

export default function deleteSelected() {
    const currentLanding: ILanding              = useLandingStore.getState().currentLanding
    const selectedType: SELECT_TYPE             = useLandingStore.getState().selectedType
    const selectedLayer : ID                    = useLandingStore.getState().selectedLayer
    const selectedMeat : ID                     = useLandingStore.getState().selectedMeat
    const selectedFloat : ID                    = useLandingStore.getState().selectedFloat
    const section: ILandingSection | undefined  = currentLanding.sections.find(section => section.id === selectedLayer)
    if(!section) return  
    const historyStep: IHistoryStep = {
        data: null,
        prevData: JSON.parse(JSON.stringify( section )),
        type: HISTORY_TYPE.SECTION,
        title: "",
    }
    
    console.log( selectedType, "selectedFloat:", selectedFloat, "selectedMeat:", selectedMeat )
    
    switch( selectedType ) {
        case SELECT_TYPE.TITLE:
            historyStep.data = {
                ...section,
                title: {} as ILandingSectionTitle,
                description: {} as ILandingSectionDescription
            }
            updateSection( 
                historyStep.data,
                {
                    ...historyStep,
                    title: __( "Delete sector's title" )
                }
            )
            break
        case SELECT_TYPE.FLOAT:
             historyStep.data = {
                ...section,
                floats: section.floats.filter( data => (data.id !== selectedFloat) )
            }
            updateSection( 
                historyStep.data,
                {
                    ...historyStep,
                    title: __( "Delete Float" )
                }
            )
            break
        case SELECT_TYPE.CONTENT:
            historyStep.data = {
                ...section,
                data: section.data.filter( data => (data.id !== selectedMeat) )
            }
            updateSection( 
                historyStep.data,
                {
                    ...historyStep,
                    title: __( "Delete Meat" )
                }
            )
            break
        default:
            return
    }
}